export default "__VITE_ASSET__BNBgljTr__"